import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const init = () => {
    let swiperInstance = null;

    document.addEventListener('DOMContentLoaded', function () {

        $('.c-look-inside__toggle').on('click', function (e) {
            // Check if Google Books implementation is handling this
            // If the button has data-isbns attribute, it means Google Books is handling it
            if ($(this).attr('data-isbns')) {
                return; // Let Google Books handle it
            }
            
            // Initialize swiper after modal is opened and content is loaded
            function initializeSwiper() {
                var swiperContainer = document.querySelector('.penguin-modal__content .c-look-inside__swiper');
                if (swiperContainer) {
                    
                    // Navigation buttons are now outside the swiper container but inside the modal content
                    var nextButton = document.querySelector('.penguin-modal__content .swiper-button-next');
                    var prevButton = document.querySelector('.penguin-modal__content .swiper-button-prev');
                    
                    
                    // Destroy existing swiper instance if it exists
                    if (swiperInstance) {
                        swiperInstance.destroy(true, true);
                        swiperInstance = null;
                    }
                    
                    try {
                        swiperInstance = new Swiper(swiperContainer, {
                            modules: [Navigation],
                            observer: true,
                            observeParents: true,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            spaceBetween: 0,
                            loop: false,
                            allowTouchMove: true,
                            speed: 300,
                            navigation: {
                                nextEl: nextButton,
                                prevEl: prevButton,
                                disabledClass: 'swiper-button-disabled',
                                hiddenClass: 'swiper-button-hidden'
                            },
                            on: {
                                init: function() {
                                    
                                    // Test if navigation is working
                                    if (this.navigation && this.navigation.nextEl) {
                                    }
                                    if (this.navigation && this.navigation.prevEl) {
                                    }
                                },
                                slideChange: function() {
                                }
                            }
                        });
                        
                        
                    } catch (error) {
                        console.error('Error creating Swiper instance:', error);
                    }
                } else {
                    // If swiper container not found, try again after a short delay
                    setTimeout(initializeSwiper, 100);
                }
            }

            // Open the modal first
            var lightbox = penguinModal('#look-inside');
            
            // Initialize swiper after modal opens - use multiple approaches for reliability
            function attemptSwiperInitialization() {
                // Try to initialize immediately
                initializeSwiper();
                
                // Also set up event listener as backup
                function handleModalOpened() {
                    setTimeout(initializeSwiper, 50);
                    document.removeEventListener('penguin-modal:opened', handleModalOpened);
                }
                document.addEventListener('penguin-modal:opened', handleModalOpened);
                
                // Fallback: try again after a longer delay
                setTimeout(initializeSwiper, 200);
            }
            
            // Start the initialization process
            attemptSwiperInitialization();
        });

    });

}

export default init;